import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Suspicion } from '../suspicion';

import { ZoonosesService } from '../zoonoses.service';

@Component({
  selector: 'app-zoonoses',
  templateUrl: './zoonoses.component.html',
  styleUrls: ['./zoonoses.component.css']
})
export class ZoonosesComponent implements OnInit {
  suspicions: Suspicion[];

  constructor(private router: Router, private zoonosesService: ZoonosesService) { }

  loadSuspicions(): void {
    this.suspicions = new Array<Suspicion>();

    this.zoonosesService.getZoonoses()
      .subscribe(
        data => {
          this.suspicions = data;

          const myself = this;

          setTimeout(function() {
            if (!myself.suspicions) { return; }

            for (const s of myself.suspicions) {
              myself.zoonosesService.getDiseases(s.id)
                .subscribe(
                  diseases => {
                    s.diseases = diseases;
                  },
                  error => {
                    console.error('Error: ', error);
                    console.error(error.headers);
                    if (error.status === 401) { // Unauthorized
                      myself.router.navigate(['/login']);
                    }
                  }
                );
            };
          }, 0);
        },
        error => {
          console.error('Error: ', error);
          if (error.status === 401) { // Unauthorized
            this.router.navigate(['/login']);
          } else {
            alert('Load error: ' + error._body);
          }
        }
      );
  }

  loadDiseases(): void {
    if (!this.suspicions) { return; }

    for (const s of this.suspicions) {
      this.zoonosesService.getDiseases(s.id)
        .subscribe(
          diseases => {
            s.diseases = diseases;
          },
          error => {
            console.error('Error: ', error);
            if (error.status === 401) { // Unauthorized
              this.router.navigate(['/login']);
            }
          }
        );
    };
  }

  ngOnInit() {
    if (!this.zoonosesService.user.name || !this.zoonosesService.user.password)
    {
      this.router.navigate(['/login']);
    } else {
      this.loadSuspicions();
    }
  }

}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/zoonoses/zoonoses.component.ts